import { Moment } from 'moment';

interface Range<T> {
  start: T | null;
  end: T | null;
}

export type DateRange = Range<Date>;
export type MomentRange = Range<Moment>;

/**
 * Tuple containing the primary and comparison date ranges.
 */
export type DateRanges = [primary: DateRange, comparison?: DateRange];
/**
 * Internally, the components use moment objects to prevent converting to and
 * from Moment/Date up and down the stack.
 */
export type MomentRanges = [primary: MomentRange, comparison: MomentRange];

export type RangeColor = 'primary' | 'secondary';
export enum RangeIndex {
  Primary,
  Comparison,
}
export enum FocusPosition {
  Start,
  StartTime,
  End,
  EndTime,
}
/**
 * Tuple containing the index of the range that is currently focused and the index
 * of the focus position (start/end).
 */
export type Focus = [range: RangeIndex, position: FocusPosition];

export const rangeIndexToColor: [RangeColor, RangeColor] = ['primary', 'secondary'];

export interface MinMaxMoment {
  min: moment.Moment | undefined;
  max: moment.Moment | undefined;
}
